import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "starter-guide-collapsed"

// Folds the "Bien démarrer" guide down to just its header, and remembers the
// choice across visits via localStorage. Arriving on the home via the sidebar
// "Bien démarrer" link (#starter_guide) force-expands it.
export default class extends Controller {
  static targets = ["head"]
  static classes = ["collapsed"]

  connect() {
    this.#apply(this.#initialCollapsed, { animate: false })
    this.boundHashChange = this.#onHashChange.bind(this)
    window.addEventListener("hashchange", this.boundHashChange)
  }

  disconnect() {
    window.removeEventListener("hashchange", this.boundHashChange)
  }

  toggle() {
    const collapsed = !this.element.classList.contains(this.collapsedClass)
    localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0")
    this.#apply(collapsed)
  }

  #apply(collapsed, { animate = true } = {}) {
    this.element.classList.toggle("starter-guide--no-transition", !animate)
    this.element.classList.toggle(this.collapsedClass, collapsed)
    this.headTarget.setAttribute("aria-expanded", String(!collapsed))

    if (!animate) requestAnimationFrame(() => this.element.classList.remove("starter-guide--no-transition"))
  }

  // On clique "Bien démarrer" alors qu'on est déjà sur la home : le hash change
  // sans recharger la page → on déroule le guide.
  #onHashChange() {
    if (this.#openedFromMenu) this.#apply(false)
  }

  // Déroulé si on arrive via le lien "Bien démarrer", sinon le choix mémorisé.
  get #initialCollapsed() {
    return this.#openedFromMenu ? false : this.#storedCollapsed
  }

  get #openedFromMenu() {
    return window.location.hash === "#starter_guide"
  }

  // Collapsed by default, until the user explicitly expands it.
  get #storedCollapsed() {
    return localStorage.getItem(STORAGE_KEY) !== "0"
  }
}
